function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconOutpostStrokeSm = function SvgIconOutpostStrokeSm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: props.color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12 13v10"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 7,
    r: 6,
    stroke: props.color
  }));
};
export default SvgIconOutpostStrokeSm;